import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import background1 from "../../assets/images/slidder1.jpg";
import background2 from "../../assets/images/slidder2.jpg";
import background3 from "../../assets/images/slidder3.jpg";
import background4 from "../../assets/images/slidder4.jpg";
import background5 from "../../assets/images/slidder5.jpg";

const HeroSlider: React.FC = () => {
  const slides = [
    background1,
    background2,
    background3,
    background4,
    background5,
  ];

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) =>
        prev === slides.length - 1 ? 0 : prev + 1
      );
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
<section className="relative w-full min-h-[80vh] sm:min-h-screen overflow-hidden">
      {/* IMAGE */}
      <div
        className="absolute inset-0 transition-all duration-700"
        style={{
          backgroundImage: `url(${slides[current]})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      {/* OVERLAY */}
      <div className="absolute inset-0 bg-black/50" />

      {/* CONTENT */}
      <div className="relative z-10 flex items-center min-h-screen px-6 md:px-20">

<div className="text-center sm:text-left max-w-2xl mx-auto sm:mx-0">
          {/* TITRE */}
<h1 className="text-white text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight">            Fabricant d'équipement de lavage self-service
          </h1>

          {/* SOUS-TITRE */}
<p className="text-gray-200 text-sm sm:text-base md:text-lg lg:text-xl mb-8">
              Créez votre propre centre de lavage dans votre région !
          </p>

          {/* BOUTONS */}
<div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto justify-center sm:justify-start">
            {/* BOUTON 1 — Nous contacter : fond bleu, flèche jaune */}
            <Link
  to="/qui-sommes-nous"
  className="group flex items-center gap-3 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-full font-semibold transition-all duration-300 shadow-lg hover:shadow-blue-500/40 hover:scale-105"
>
  <span className="flex items-center justify-center w-6 h-6 rounded-full bg-blue-500 group-hover:bg-blue-400 transition-colors duration-300">
    <svg
      className="w-3 h-3 text-white"
      fill="none"
      stroke="currentColor"
      strokeWidth={3}
      viewBox="0 0 24 24"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
    </svg>
  </span>
  En savoir plus
</Link>
            {/* BOUTON 2 — Qui sommes-nous : transparent → bleu au clic/hover */}
<Link
  to="/contact"
  className="group flex items-center gap-3 border-2 border-yellow-400 hover:bg-blue-600 hover:border-blue-600 text-white px-6 py-3 rounded-full font-semibold transition-all duration-300 shadow-lg hover:shadow-blue-500/40 hover:scale-105"
>
  <span className="flex items-center justify-center w-6 h-6 rounded-full border-2 border-white group-hover:border-white group-hover:bg-white/20 transition-colors duration-300">
    <svg
      className="w-3 h-3 text-white"
      fill="none"
      stroke="currentColor"
      strokeWidth={3}
      viewBox="0 0 24 24"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
    </svg>
  </span>
  Contactez-nous
</Link>
          </div>

        </div>

      </div>
    </section>
  );
};

export default HeroSlider;